const recipientDetailsFields = {
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    message: 'message'
};

export default recipientDetailsFields;